(function () {
  const config = window.themeWishlistFeedback || {};
  const buttonSelector = [
    '.collection-product-card .swym-advanced-wishlist-collections',
    '.collection-product-card .swym-wishlist-collections-v2',
    '.collection-product-card .swym-add-to-wishlist',
    '.collection-product-card button[class*="swym"]',
    '.collection-product-card [role="button"][class*="swym"]',
    '.collection-product-card [aria-label*="wishlist" i]',
    '.collection-product-card [aria-label*="wish" i]'
  ].join(',');
  const headerTargetSelectors = [
    '.header [class*="swym"][href*="wishlist"]',
    '.header button[class*="swym"][aria-label*="wishlist" i]',
    '.header a[href*="wishlist"]',
    '.header [data-swaction*="Wishlist"]',
    '.header [class*="wishlist"]'
  ];

  let toastTimer;
  let swatApi;

  const getToast = () => {
    let toast = document.querySelector('.wishlist-feedback-toast');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'wishlist-feedback-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
    return toast;
  };

  const showToast = (message) => {
    if (!message) return;

    const toast = getToast();
    toast.textContent = message;
    toast.classList.add('is-visible');

    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2600);
  };

  const findHeaderTarget = () => {
    for (const selector of headerTargetSelectors) {
      const target = document.querySelector(selector);
      if (target) return target;
    }
    return null;
  };

  const ensureCountBadge = () => {
    const target = findHeaderTarget();
    if (!target) return null;

    target.classList.add('wishlist-feedback-count-wrapper');

    let badge = target.querySelector('.wishlist-feedback-count');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'wishlist-feedback-count';
      target.appendChild(badge);
    }

    return badge;
  };

  const setCount = (count) => {
    const badge = ensureCountBadge();
    if (!badge || Number.isNaN(count)) return;

    badge.textContent = count > 99 ? '99+' : String(count);
    badge.setAttribute('aria-label', (config.countLabel || 'Wishlist items: [count]').replace('[count]', count));
    badge.classList.toggle('is-visible', count > 0);
  };

  const translatePageLabels = () => {
    const labels = config.pageLabels || {};
    const path = window.location.pathname;
    const isWishlistPage = path.includes('/pages/swym-wishlist');
    const isSharedWishlistPage = path.includes('/pages/swym-share-wishlist');

    if (!isWishlistPage && !isSharedWishlistPage) return;

    const replacements = isSharedWishlistPage
      ? [
          { from: /^Shared Wishlist$/i, to: labels.sharedWishlist },
          { from: /^Wishlist$/i, to: labels.wishlist }
        ]
      : [
          { from: /^My Wishlist$/i, to: labels.myWishlist || labels.wishlist },
          { from: /^Wishlist$/i, to: labels.wishlist }
        ];

    replacements.push(
      { from: /^Save things as you browse$/i, to: labels.emptyHeading },
      { from: /^Tap ♡ on any product\. It lands here so you don't lose it\.$/i, to: labels.emptyText },
      { from: /^Saves stay through this session\. Log in to keep them permanently\.$/i, to: labels.sessionNotice },
      { from: /^Log in to save permanently\s*→?$/i, to: labels.loginSave },
      { from: /^Keep browsing first$/i, to: labels.keepBrowsing },
      { from: /^No account\?$/i, to: labels.noAccount },
      { from: /^Sign up — it takes a minute$/i, to: labels.signUp }
    );

    const textNodeReplacements = [
      { from: /Save things as you browse/gi, to: labels.emptyHeading },
      { from: /Tap ♡ on any product\. It lands here so you don't lose it\./gi, to: labels.emptyText },
      { from: /Saves stay through this session\./gi, to: labels.sessionNotice },
      { from: /Log in to keep them permanently\./gi, to: '' },
      { from: /Log in to save permanently/gi, to: labels.loginSave },
      { from: /Keep browsing first/gi, to: labels.keepBrowsing },
      { from: /No account\?/gi, to: labels.noAccount },
      { from: /Sign up — it takes a minute/gi, to: labels.signUp }
    ];

    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      let value = walker.currentNode.nodeValue;
      textNodeReplacements.forEach((item) => {
        if (item.to && !item.to.includes('translation missing')) value = value.replace(item.from, item.to);
      });
      walker.currentNode.nodeValue = value.replace(/\s{2,}/g, ' ').trimStart();
    }

    document.querySelectorAll('h1, h2, h3, span, div, button, a').forEach((element) => {
      const text = element.textContent && element.textContent.trim();
      if (!text || element.children.length > 0) return;

      const replacement = replacements.find((item) => item.to && !item.to.includes('translation missing') && item.from.test(text));
      if (replacement) {
        element.textContent = replacement.to;
        element.setAttribute('aria-label', replacement.to);
      }
    });
  };

  const fetchWishlistCount = async () => {
    if (!swatApi || typeof swatApi.fetchLists !== 'function' || typeof swatApi.fetchListCtx !== 'function') {
      return;
    }

    try {
      const lists = await new Promise((resolve, reject) => {
        swatApi.fetchLists({
          callbackFn: resolve,
          errorFn: reject
        });
      });

      if (!Array.isArray(lists) || !lists.length) {
        setCount(0);
        return;
      }

      const counts = await Promise.all(
        lists.map((list) =>
          new Promise((resolve) => {
            swatApi.fetchListCtx(
              { lid: list.lid },
              (items) => resolve(Array.isArray(items) ? items.length : 0),
              () => resolve(0)
            );
          })
        )
      );

      setCount(counts.reduce((total, count) => total + count, 0));
    } catch (error) {
      // Keep wishlist behavior untouched if Swym count APIs are unavailable.
    }
  };

  const pulseButton = (button) => {
    button.classList.add('is-feedback-active');
    window.setTimeout(() => button.classList.remove('is-feedback-active'), 280);
  };

  const handleWishlistClick = (event) => {
    const button = event.target.closest(buttonSelector);
    if (!button) return;

    const wasPressed = button.getAttribute('aria-pressed') === 'true';

    window.setTimeout(() => {
      const isPressed = button.getAttribute('aria-pressed') === 'true';
      const message = isPressed !== wasPressed
        ? (isPressed ? config.added : config.removed)
        : (wasPressed ? config.removed : config.added);

      pulseButton(button);
      showToast(message);
      fetchWishlistCount();
    }, 700);
  };

  const initWithSwym = (swat) => {
    swatApi = swat;
    fetchWishlistCount();
    translatePageLabels();
  };

  document.addEventListener('click', handleWishlistClick, true);

  if (!window.SwymCallbacks) window.SwymCallbacks = [];
  window.SwymCallbacks.push(initWithSwym);

  window.setTimeout(fetchWishlistCount, 1800);
  window.setTimeout(translatePageLabels, 500);
  window.setTimeout(translatePageLabels, 1800);
  new MutationObserver(translatePageLabels).observe(document.body, { childList: true, subtree: true });
})();
